<span class="grid-header-padding">
    {{ params.displayName }}
</span>